import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useState } from 'react';
export function useBalloon() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      isBalloonOpened = _useState2[0],
      setIsBalloonOpened = _useState2[1];

  var toggleBalloon = useCallback(function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return setIsBalloonOpened(typeof toggle == 'boolean' ? toggle : !isBalloonOpened);
  }, [isBalloonOpened]);
  var closeBalloon = useCallback(function () {
    return setIsBalloonOpened(false);
  }, []);
  return {
    isBalloonOpened: isBalloonOpened,
    toggleBalloon: toggleBalloon,
    closeBalloon: closeBalloon
  };
}